export default function PaginationSwiper({ active }: { active: number }) {
  return (
    <div className="absolute bottom-5 left-0 right-0 mx-auto w-fit z-30 flex gap-2.5">
      {Array.from({ length: 3 }).map((e, i) => (
        <div
          key={i + "pagination-banner"}
          className={`w-3 h-3 rounded-full duration-200 ${
            active === i
              ? "bg-primary-500 outline-1 outline-primary-500 outline-offset-4"
              : "bg-white"
          }`}
        ></div>
      ))}
    </div>
  );
}
